export const festivalDayOffset = [-7, "hours"];